/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-nested-ternary */
import React from 'react'
import _ from 'lodash'
// import { useTheme } from 'react-jss'
import { useTranslation } from 'react-i18next'
import useStyles from './coupon-card-style'
import CouponStateLabel from '../coupon-state-label'

import combineClassNames from '../../helpers/combineClassNames'
import { useThemeConfig } from '../../hook/use-theme-config'
import Image from '../image'

const CouponCardView = (props) => {
  const {
    className,
    contentClassName,
    thumbnailClassName,
    thumbnailImageClassName,
    titleClassName,
    descriptionClassName,
    upperContentClassName,

    type,
    // miniCartCoupon,
    id,
    displayImage,
    imageUrl,
    title,
    description,
    displayTimeLabel,
    displayTime,
    sharedLabel,
    state,
    stateLabel,
    disabled,
    requiredPoints,
    onSelect,
    isExpired,
    isTransferable,
    isTransferInProgress,
    isNonStarted,
    status,
    statusLabel: _statusLabel,
    usableCouponTokenCount,
  } = props

  // prepare hook
  const { t } = useTranslation()
  const { getConfig } = useThemeConfig()
  const hideLoyaltyPoints = getConfig('config.hideLoyaltyPoints', false)

  const usableCouponTokenCountLabel = t('ui.couponCard.usableCouponTokenCount', { count: usableCouponTokenCount })
  const showRequiredPoints = !_.isUndefined(requiredPoints) && !hideLoyaltyPoints

  const styles = useStyles()

  function classStatus(couponStatus) {
    switch (couponStatus) {
      case 'success':
        return styles.add
      case 'error':
        return styles.redeem
      default:
        return styles.used
    }
  }

  function handleSelect() {
    if (_.isFunction(onSelect) && !disabled) {
      onSelect({ id, type })
    }
  }

  const statusType = isExpired && status === 'usable' ? 'expired' : _.camelCase(status)
  const statusLabel = isExpired && status === 'usable'
    ? t('ui.minicartCoupons.couponStateLabel', { context: 'expired' })
    : _statusLabel

  let footerRightContent = null
  if (showRequiredPoints) {
    footerRightContent = t('ui.couponCard.pointToRedeem', { points: requiredPoints })
  }
  if (!_.isEmpty(statusLabel)) {
    footerRightContent = t(
      'ui.couponCard.statusLabel',
      {
        context: statusType,
        defaultValue: statusLabel,
      },
    )
  }
  if (!_.isEmpty(sharedLabel)) {
    footerRightContent = sharedLabel
  }

  return (
    <div
      role="button"
      onClick={handleSelect}
      tabIndex={0}
      className={combineClassNames([
        styles.container,
        disabled && styles.disabled,
        className,
      ])}
    >
      <div
        className={combineClassNames([styles.upperContent, upperContentClassName])}
      >
        {
          displayImage && (
            <figure
              className={combineClassNames([styles.figure, thumbnailClassName])}
            >
              <Image
                alt={title}
                className={combineClassNames([styles.image, thumbnailImageClassName])}
                // placeholderClassName={combineClassNames([styles.noImage])}
                src={imageUrl}
              />
            </figure>
          )
        }
        <div
          className={combineClassNames([styles.content, contentClassName])}
        >
          {
            !_.isEmpty(title) && (
              <h1
                className={combineClassNames([
                  styles.contentText,
                  styles.title,
                  titleClassName,
                ])}
              >
                {title}
              </h1>
            )
          }
          {
            !_.isEmpty(stateLabel) && (
              <p className={classStatus(state)}>
                {stateLabel}
              </p>
            )
          }
          {description && (
            <div
              className={combineClassNames([
                styles.contentText,
                styles.description,
                descriptionClassName,
              ])}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )}
        </div>
      </div>
      {
        (usableCouponTokenCount <= 1 || _.isNil(usableCouponTokenCount)) && (
          <div className={styles.footer}>
            <dl
              className={
                combineClassNames([
                  styles.footerLeft,
                ])
              }
            >
              <dt>{displayTimeLabel}</dt>
              <dd>{displayTime}</dd>
            </dl>
            {
              footerRightContent && (
                <div
                  className={
                    combineClassNames([
                      styles.footerRight,
                    ])
                  }
                >
                  {footerRightContent}
                </div>
              )
            }
          </div>
        )
      }
      {
        usableCouponTokenCount > 1 && (
          <div className={styles.usableCouponTokenCountContainer}>
            <div className={styles.usableCouponTokenCount}>
              <span className={styles.usableCouponTokenCountLabel}>
                {usableCouponTokenCountLabel}
              </span>
            </div>
          </div>
        )
      }
      <CouponStateLabel
        {...{
          isExpired,
          isNonStarted,
          isTransferable,
          isTransferInProgress,
          isUsable: status === 'usable',
        }}
      />
    </div>
  )
}

export default CouponCardView
